export const SET_GAME_STARTED = 'SET_GAME_STARTED';
export const SET_ANSWER = 'SET_ANSWER'
export const SUMBIT_ANSWER = 'SUMBIT_ANSWER'
export const SAVE_USER_NAME = 'SAVE_USER_NAME'
export const QUIZ = {
    FETCH_SUCCESS: 'QUESTION_FETCH_SUCCESS',
    FETCH_ERROR: 'QUESTION_FETCH_ERROR'
}